module.exports = __webpack_public_path__ + "static/media/avatar_profissionais-empresas.c3fe1581.svg";